import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            漫画分类
          </h2>
          <p className="mt-2 text-sm text-foreground-500">按类型浏览，找到你喜欢的韩漫</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group flex flex-col items-center p-6 md:p-8 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 transition-all duration-200"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="mt-4 text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="mt-2 text-xs text-foreground-500 text-center line-clamp-2">
                {cat.description}
              </p>
              <span className="mt-3 text-xs text-primary-600 font-medium">
                {cat.count} 部作品
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}